import React from "react";
import { Box, Typography, Link } from "@mui/material";

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#0B2039",
        color: "#ffffff",
        padding: "6px 0px",
        textAlign: "center",
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.3)",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Typography variant="body2" sx={{ marginBottom: "8px" }}>
        Aplicación creada por{" "}
        <Link
          href="https://ashtronic.com"
          target="_blank"
          rel="noopener"
          sx={{ color: "#737373", textDecoration: "none" }}
        >
          Ashtronic
        </Link>
      </Typography>
      <Typography variant="body2">
        ¿Necesitas ayuda? Contacta a nuestro{" "}
        <Link
          href="mailto:tecnico@ashtronic.com"
          sx={{ color: "#737373", textDecoration: "none" }}
        >
          soporte técnico tecnico@ashtronic.com
        </Link>
      </Typography>
    </Box>
  );
};

export default Footer;